export const groupDeactivationEnum = Object.freeze({
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate',
});
